<script lang="ts" setup>
// eslint-disable-next-line
import OverviewContent from './OverviewContent.vue';
</script>

<template>
  <Suspense>
    <OverviewContent />
  </Suspense>
</template>
